import { TGetLatestChatFilesResponse } from '../../types/file';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatImagesActionTypes {
  SetChatImagesPending = 'chat/images/getChatImagesPending',
  SetChatImagesSucceed = 'chat/images/getChatImagesSucceed',
  SetChatImagesFailed = 'chat/images/getChatImagesFailed',
  SetChatImagesEmpty = 'chat/images/setChatImagesEmpty',
}

export type TChatImagesPayload = {
  chatId: string;
};

export type TChatImagesSucceedPayload = {
  chatId: string;
} & TGetLatestChatFilesResponse;

export type TChatImagesActions =
  | ITypedReduxAction<EChatImagesActionTypes.SetChatImagesPending, TChatImagesPayload>
  | ITypedReduxAction<EChatImagesActionTypes.SetChatImagesSucceed, TChatImagesSucceedPayload>
  | ITypedReduxAction<EChatImagesActionTypes.SetChatImagesEmpty, TChatImagesPayload>
  | ITypedReduxAction<EChatImagesActionTypes.SetChatImagesFailed, TChatImagesPayload>;
